import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';

import { FormItem, FormWrapper } from '@page/integrations/integrations.page-style';
import { Select } from '@style/global-style.app';

import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { useSearchLocation } from '@hook/common/use-search-location.hook';
import { isExist, isString } from '@util/data/is-exist';

import { LogsFilterProps } from './logs-filter.interface';

const serviceIds = Object.entries(ConnectorServiceEnum).map(([key, value]) => ({ label: key, value }));

export const LogsFilter = ({ onChange }: LogsFilterProps) => {
  const [{ serviceId: searchServiceId }, setSearchParams] = useSearchLocation();
  const [serviceId, setService] = useState<ConnectorServiceEnum>(
    isString(searchServiceId) ? (searchServiceId as ConnectorServiceEnum) : null!,
  );
  const [dateFrom, setDateFrom] = useState<Dayjs>(null!);
  const [dateTo, setDateTo] = useState<Dayjs>(null!);
  const disabledDateStart: RangePickerProps['disabledDate'] = (current) => {
    if (!isExist(current)) return false;
    if (isExist(dateTo)) return current.isSame(dateTo) || current.isAfter(dateTo);
    return current.isAfter(dayjs());
  };

  const disabledDateEnd: RangePickerProps['disabledDate'] = (current) => {
    if (!isExist(current)) return false;
    if (isExist(dateFrom)) return !(!current.isAfter(dayjs()) && !current.isBefore(dateFrom));
    return current.isAfter(dayjs());
  };

  useEffect(() => void setSearchParams({ serviceId }), [serviceId]);

  useEffect(
    () =>
      onChange({
        serviceId,
        dateFrom,
        dateTo,
      }),
    [serviceId, dateFrom, dateTo],
  );

  return (
    <FormWrapper autoComplete='off' layout='vertical' name='webhook'>
      <FormItem label='Filter by Service'>
        <Select options={[{ label: 'All', value: null }, ...serviceIds]} value={serviceId} onChange={setService} />
      </FormItem>
      <FormItem label='Filter by Start Date'>
        <DatePicker
          disabledDate={disabledDateStart}
          format='YYYY-MM-DD HH:mm:ss'
          showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
          size='large'
          value={dateFrom}
          onChange={(value) => setDateFrom(value)}
        />
      </FormItem>
      <FormItem label='Filter by End Date'>
        <DatePicker
          disabledDate={disabledDateEnd}
          format='YYYY-MM-DD HH:mm:ss'
          showTime={{ defaultValue: dayjs() }}
          size='large'
          value={dateTo}
          onChange={(value) => setDateTo(value)}
        />
      </FormItem>
    </FormWrapper>
  );
};
